import { Injectable } from '@angular/core';
import { ApiConstants, CustomHttp } from '../shared';

@Injectable()
export class InAppNotificationsService {
    constructor(private http: CustomHttp, private ApiConstants: ApiConstants) {}

    getBaseURL() {
        return this.ApiConstants.ENDPOINT_NOTIFICATIONS;
    }

    getNotifications(user: string, page: number = 0) {
        const url = `${this.getBaseURL()}?user=${user}&page=${page}`;

        return this.http.get(url);
    }

    postRead(notificationId: number) {
        const url = `${this.getBaseURL()}/read?notificationId=${notificationId}`;

        return this.http.post(url, {});
    }

    postNotification(to: string, from: string, subject: string, message: string) {
        const url = `${this.getBaseURL()}?to=${to}&from=${from}&subject=${encodeURIComponent(subject)}&message=${encodeURIComponent(message)}`;

        return this.http.post(url, {});
    }

}


// WEBPACK FOOTER //
// ./src/app/notifications/notifications.service.ts